import React from 'react'
import { connect } from 'react-redux'
import { selectProjectsByOrder, selectProjectsStatus } from '../../../store/projects'

import Content from '../../ui/Content'
import Error from '../../ui/Error'
import Loading from '../../ui/Loading'
import ProgressTiles from '../../ui/ProgressTiles'
import Section from '../../ui/Section'

const ProjectTiles = ({
  action,
  alignment,
  backgroundImage,
  background,
  barColor,
  buttonBackground,
  buttonForeground,
  copy,
  copyAlignment,
  foreground,
  fundedAction,
  metric,
  projects = [],
  size,
  spacing,
  status,
  subtitle,
  title,
  titleForeground,
  titleSize
}) => {
  const data = projects.map((project) => {
    const isFunded = metric === 'donations'
      ? project.totalDonations >= project.targetDonations
      : project.raised >= project.target

    const isDisabled = isFunded && fundedAction === 'disable'

    return {
      ...project,
      actions: [{
        to: action === 'view'
          ? isDisabled ? '' : project.url
          : isDisabled ? '' : project.donationUrl || project.donateUrl,
        label: action === 'view'
          ? isDisabled ? 'Project Funded' : 'View Project'
          : isDisabled ? 'Project Funded' : 'Donate Now'
      }]
    }
  })

  return (
    <Section
      alignment={alignment}
      backgroundImage={backgroundImage}
      background={background}
      foreground={foreground}
      size={size}
      spacing={spacing}>

      <Content
        copy={copy}
        copyAlignment={copyAlignment}
        subtitle={subtitle}
        title={title}
        titleForeground={titleForeground}>

        {status === 'fetching' && <Loading />}
        {status === 'failed' && <Error>There was an error loading current projects.</Error>}
        {status === 'fetched' && (
          <ProgressTiles
            action={action}
            barColor={barColor}
            buttonBackground={buttonBackground}
            buttonForeground={buttonForeground}
            data={data}
            metric={metric}
            titleForeground={titleForeground}
            titleSize={titleSize}
          />
        )}

      </Content>
    </Section>
  )
}

const mapState = (state) => ({
  status: selectProjectsStatus(state),
  projects: selectProjectsByOrder(state)
})

export default connect(mapState)(ProjectTiles)



// WEBPACK FOOTER //
// ./components/slices/ProjectTiles/index.js